<!-- 订单提交页 -->
<template>
  <div class="panel">
    <div class="box">
      <h3>订单信息：</h3>
      <table>
        <thead>
          <tr>
            <th>服务名称</th>
            <th>项目名称</th>
            <th>规格名称</th>
            <th>微盟套餐优惠(元)</th>
            <th>实付(元)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>国内短信包</td>
            <td>国内短信包</td>
            <td>{{ chose != "a" ? prices[chose].product : "" }}</td>
            <td>{{ chose != "a" ? prices[chose].money : "" }}</td>
            <td>{{ chose != "a" ? prices[chose].money : "" }}</td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td>
              付款小计：<span style="color: red;">{{
                chose != "a" ? prices[chose].money : ""
              }}</span>
              元
            </td>
          </tr>
        </tbody>
      </table>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="订单备注">
          <el-input
            type="textarea"
            v-model="form.desc"
            placeholder="有啥要求请配置"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="bottom">
        <h5>付款小计：{{ chose != "a" ? prices[chose].money : "" }} 元</h5>
        <el-button type="warning" @click="dialogTableVisible = true"
          >提交订单</el-button
        >
      </div>
      <!-- 彈窗 -->
      <el-dialog
        title="支付详情"
        :visible.sync="dialogTableVisible"
        width="420px"
      >
        <ul class="dialog">
          <li>
            <div class="title">订单号：</div>
            <div class="liRight">1607805732973936640</div>
          </li>
          <li>
            <div class="title">商品名称：</div>
            <div class="liRight">国内短信包</div>
          </li>
          <li>
            <div class="title">应付金额：</div>
            <div class="liRight" style="color: red; font-size: 24px">
              {{ chose != "a" ? prices[chose].money : "" }}
            </div>
          </li>
          <li>
            <div class="title">订单号：</div>
            <div class="liRight">1607805732973936640</div>
          </li>
          <li>
            <div class="title"></div>
            <div class="liRight">
              <el-button type="warning">去支付</el-button>
            </div>
          </li>
        </ul>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prices: [
        {
          money: "100",
          product: "1000条"
        },
        {
          money: "180",
          product: "2000条"
        },
        {
          money: "250",
          product: "3000条"
        },
        {
          money: "400",
          product: "5000条"
        },
        {
          money: "3000",
          product: "50000条"
        }
      ],
      chose: "a",
      form: {
        desc: ""
      },
      dialogTableVisible: false
    };
  },
  methods: {},
  mounted() {
    if (this.$route.query.message) {
      this.chose = this.$route.query.message;
      console.log("chose", this.chose);
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.panel {
  padding-top: 14px;
  height: 100%;
  .box {
    padding: 10px;
    border-radius: 6px;
    background: #f2f2f6;
    h3 {
      padding: 12px 0;
    }
    table {
      width: 100%;
      border-radius: 6px;
      border: 1px solid #e7e7e7;
      tr {
        height: 36px;
        line-height: 36px;
        border-bottom: 1px solid #e7e7e7;
      }
      // tr:first-child {
      //   border: none;
      // }
      td {
        text-align: center;
      }
      thead {
        background: #fff;
      }
    }
    .el-form {
      margin-top: 20px;
    }
    .bottom {
      // float: right;
      text-align: right;
      height: 100px;
      padding: 0 10px;
      h5 {
        height: 60px;
        padding-top: 20px;
      }
    }
  }
}
//弹窗
.dialog {
  width: 100%;
  font-size: 14px;
  li {
    display: flex;
    padding: 5px 0;
    .title {
      width: 80px;
    }
  }
}
</style>
